"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isZoeeUserDetail = void 0;
var yup = require("yup");
var zoeeUserDetailsSchema = yup.object().shape({
    email: yup.string().required(),
    isActive: yup.boolean().required(),
    isPowerUser: yup.boolean().required(),
    isProcurementUser: yup.boolean().required(),
    isWarehouseManager: yup.boolean().required(),
    name: yup.string().required(),
    superVisorName: yup.string().required(),
    warehouseId: yup.string().required(),
});
function isZoeeUserDetail(obj) {
    return zoeeUserDetailsSchema.isValidSync(obj);
}
exports.isZoeeUserDetail = isZoeeUserDetail;
